<template>
  <div>
    <md-landscape v-model="visible" class="landscape-container">
      <img class="image" :src="imgUrl" @click="switchRoute">
    </md-landscape>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      imgUrl: '',
      redirectUrl: '',
    }
  },
  mounted() {
    if (this.$store.getters.loggedin) {
      this.getPopup()
    }
  },
  methods: {
    async getPopup() {
      try {
        const response = await this.$http.get('/popups', { params: { client: 'H5' } })
        const data = response.data
        if (data && data.imgUrl && data.imgUrl.h5) {
          this.visible = true
          this.imgUrl = data.imgUrl.h5
          this.redirectUrl = data.redirectUrl.h5
        }
      } catch (error) {
        console.log(error)
      }
    },
    switchRoute() {
      if (this.redirectUrl) {
        this.$router.push(this.redirectUrl)
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.image
  width 80%
  display block
  margin 0 auto

</style>
